export enum AptDeliveryChannelQuote {
    Digitale = 'Digitale',
    Stampa = 'Stampa',
}
